var _path, _path2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 57.75C17.01 57.75 5.25 45.99 5.25 31.5C5.25 17.01 17.01 5.25 31.5 5.25C45.99 5.25 57.75 17.01 57.75 31.5C57.75 45.99 45.99 57.75 31.5 57.75ZM40.9333 32.3C41.4667 31.9 41.4667 31.1 40.9333 30.7L27.85 20.8875C27.1908 20.3931 26.25 20.8635 26.25 21.6875V41.3125C26.25 42.1365 27.1908 42.6069 27.85 42.1125L40.9333 32.3Z",
    fill: "#C2D1D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_199_1389",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 53,
    height: 53
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 57.75C17.01 57.75 5.25 45.99 5.25 31.5C5.25 17.01 17.01 5.25 31.5 5.25C45.99 5.25 57.75 17.01 57.75 31.5C57.75 45.99 45.99 57.75 31.5 57.75ZM40.9333 32.3C41.4667 31.9 41.4667 31.1 40.9333 30.7L27.85 20.8875C27.1908 20.3931 26.25 20.8635 26.25 21.6875V41.3125C26.25 42.1365 27.1908 42.6069 27.85 42.1125L40.9333 32.3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_199_1389)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.af73438d54d7ff09070555cf8ed8ba73.svg";
export { ForwardRef as ReactComponent };